'use client'
import styles from "@/styles/product-detail/search-bar.module.scss";
import { useState, useEffect, useRef } from 'react';
import Image from 'next/image';
import { Input } from 'react-vant';
import { Clear } from "@react-vant/icons";
import { debounce } from 'radash';
import systemApi from '@/service/modules/systemApi';
import { matomoSetCustomDimension, matomoSetArrCustomDimension } from '@/utils/matomoEvent';

interface ProductDetailSearchBarProps {
  onClose?: () => void;
}

export default function ProductDetailSearchBar({ onClose }: ProductDetailSearchBarProps) {
  const [value, setValue] = useState('');
  const [recommentProduct, setRecommentProduct] = useState<string[]>([]);
  const [showRecommendations, setShowRecommendations] = useState(false);

  const debouncedSearch = useRef(
    debounce({ delay: 300 }, async (searchValue: string) => {
      try {
        if (searchValue.length >= 3) {
          const { data } = await systemApi.searchSuggest({ keyword: searchValue });
          if (data?.suggestKeywords && Array.isArray(data.suggestKeywords)) {
            setRecommentProduct(data.suggestKeywords);
            setShowRecommendations(true);
          }
        } else {
          handleCloseRecommendations();
        }
      } catch (error) {
        console.error('搜索建议请求失败:', error);
        handleCloseRecommendations();
      }
    })
  ).current;

  // 监听输入值变化
  useEffect(() => {
    if (value.length >= 3) {
      debouncedSearch(value);
    } else {
      setRecommentProduct([]);
      setShowRecommendations(false);
    }
  }, [value, debouncedSearch]);

  const handleCloseRecommendations = () => {
    setTimeout(() => {
      setRecommentProduct([]);
      setShowRecommendations(false);
    }, 100);
  };

  const handleViewDatail = (item: string) => {
    setShowRecommendations(false);
    matomoSetArrCustomDimension([{ dimension: 4, value: item }, { dimension: 1, value: true }])
    window.location.href = `/search/${item.replace(/ /g, '+')}`;
  };

  // 处理搜索提交
  const handleSearch = () => {
    if (value.trim()) {   
      const keyword = value.replace(/ /g, "+")

      matomoSetCustomDimension(4, keyword.replace(/\s/g, '+'))
      window.location.href = `/search/${keyword.replace(/\s/g, '+')}`
    }
  };

  // 处理回车键按下事件
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };


  return (
    <div className={styles['comp-search-bar']}>
      <div className={styles['search-bar-content']}>
        <div className={styles['search-input-box']}>
          <Input 
            className={styles['input']} 
            prefix={
              <Image 
                src={`${process.env.IMAGE_DOMAIN}/svg/icon-search.svg`} 
                alt={'search-icon'}
                width={30}
                height={30}
                onClick={handleSearch}
              />
            }
            placeholder="Search Products….."
            value={value}
            onChange={setValue}
            onClear={handleCloseRecommendations}
            onBlur={handleCloseRecommendations}
            onKeyDown={handleKeyDown}
            clearable
            clearTrigger="always"
          />
        </div>

        <Clear 
          color="#FFFFFF" 
          fontSize={32} 
          className={styles['close-search-icon']} 
          onClick={onClose}
        />
      </div>

      {showRecommendations && recommentProduct.length > 0 && (
        <div className={styles['recommendations']}>
          {recommentProduct.map((item, index) => (
            <div 
              key={index} 
              className={styles['recommendation-item']}
              onClick={() => {handleViewDatail(item)}}
            >
              {item}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
